import { useEffect, useState } from "react";
import client from "../utils/client";
import { defaultPowerDatas } from "../constants/defaultPowerDatas";
import { normalizePowerRecords } from "../utils/powerData";
import { NormalizedPowerRow, PowerRecord } from "../types/power";

export type PowerDataSource = "api" | "mock";

const fallbackRows = normalizePowerRecords(
  defaultPowerDatas as unknown as PowerRecord[],
);

export const usePowerData = () => {
  const [rows, setRows] = useState<NormalizedPowerRow[]>(fallbackRows);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [source, setSource] = useState<PowerDataSource>("mock");

  useEffect(() => {
    let isActive = true;

    const load = async () => {
      setIsLoading(true);
      setError(null);

      try {
        const response = await client.get<PowerRecord[]>("/fetch-details");
        const payload = Array.isArray(response.data) ? response.data : [];
        const normalized = normalizePowerRecords(payload);

        if (normalized.length) {
          if (isActive) {
            setRows(normalized);
            setSource("api");
          }
        } else if (isActive) {
          setRows(fallbackRows);
          setSource("mock");
        }
      } catch (loadError) {
        if (isActive) {
          setError("Unable to reach live data. Showing cached data instead.");
          setRows(fallbackRows);
          setSource("mock");
        }
      } finally {
        if (isActive) {
          setIsLoading(false);
        }
      }
    };

    load();

    return () => {
      isActive = false;
    };
  }, []);

  return { rows, isLoading, error, source };
};
